import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useApolloClient, useQuery } from '@apollo/client';
import { useDisclosure } from '@mantine/hooks';
import { GET_QUESTIONS } from '@queries/questions';
import { GET_TRIP_PROFILE } from '@queries/trip-profiles';
import Questionnaire from '@components/questionnaire';
import Breadcrumb from '@components/breadcrumb';
import NextNav, { SaveFunction } from '@components/next-nav';
import NewTripModal from '@components/new-trip-modal';
import { QuestionType } from '@generated/graphql';
import { Group } from '@mantine/core';

function SurveyLayerGroups() {
  const { clientId, tripProfileId } = useParams();

  // get cached questions
  const apolloClient = useApolloClient();
  const questions = apolloClient.readQuery({
    query: GET_QUESTIONS,
  });

  // Check destination — show choice modal if none set yet
  const { data: profileData, loading: profileLoading } = useQuery(GET_TRIP_PROFILE, {
    variables: { id: tripProfileId || '' },
    skip: !tripProfileId,
    fetchPolicy: 'cache-first',
  });
  const hasDestination = Boolean(profileData?.singleTripProfile?.destinationId);
  const [modalOpened, { open: openModal, close: closeModal }] = useDisclosure(false);

  useEffect(() => {
    if (!profileLoading && !hasDestination) {
      openModal();
    }
  }, [profileLoading, hasDestination, openModal]);

  let groupQuestions = questions?.findQuestions.filter((question) => question.type === QuestionType.LayerGroup);
  if (!groupQuestions) groupQuestions = [];

  return (
    <>
      <NewTripModal
        opened={modalOpened && !profileLoading && !hasDestination}
        onClose={closeModal}
        clientId={clientId || ''}
        tripProfileId={tripProfileId || ''}
      />
      <Breadcrumb pageStep={1} />
      <Questionnaire title="Travel Themes - Categories" questions={groupQuestions} />
      <Group justify="flex-end" align="center">
        {/* TODO: Do we want or need to have the save between these pages?  Cause a UX "delay" */}
        <NextNav
          next={`/clients/${clientId}/trip-profiles/${tripProfileId}/layers`}
          saveFunctionName={SaveFunction.SaveQuestionnaire}
        />
      </Group>
    </>
  );
}

export default SurveyLayerGroups;
